module.exports = __webpack_public_path__ + "img/Toss(Button).486cc0f9.svg";